
import { defineComponent } from "vue";
import SideBar from "./components/SideBar.vue";
import Forms from "./components/Forms.vue";
import Task from "./components/Task.vue";
import TaskInterface from "./interface/TaskInterface";
import NoTask from "./components/NoTask.vue";

export default defineComponent({
  name: "App",
  data() {
    const tasksSaved: { description: string; duration: number }[] = JSON.parse(
      localStorage.getItem("tasks") ?? "[]"
    );
    return {
      tasksSaved: tasksSaved,
      tasks: [] as TaskInterface[],
      setModeActive: false,
    };
  },
  computed: {
    tasksEmpty(): boolean {
      if (this.tasksSaved.length !== 0) {
        return false;
      } else {
        return this.tasks.length === 0;
      }
    },
    taskSaveLocalStorage(): boolean {
      return this.tasksSaved.length !== 0;
    },
  },
  components: { SideBar, Forms, Task, NoTask },
  methods: {
    saveTask(task: TaskInterface) {
      this.tasks.push(task);
    },
    changingTheme(stage: boolean) {
      this.setModeActive = stage;
    },
  },
});
